

export const Trashcan = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="19" viewBox="0 0 17 19" fill="none">
            <path d="M14.1313 4.16663H3.4646V16.6111C3.4646 17.102 3.86257 17.5 4.35349 17.5H13.2424C13.7333 17.5 14.1313 17.102 14.1313 16.6111V4.16663Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M1.68677 4.16663H15.909" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.4647 1.5H6.13132C5.6404 1.5 5.24243 1.89797 5.24243 2.38889V4.16667H12.3535V2.38889C12.3535 1.89797 11.9556 1.5 11.4647 1.5Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}